import { createContext, useContext, useState } from "react";
import { useAxiosInterceptor } from "shared/hooks";
import { useSignalR } from "../hooks";

const HubConnectionContext = createContext();

export const HubConnectionProvider = ({ children }) => {
    const [connection, setConnection] = useState(null);
    const [connectionId, setConnectionId] = useState(null);
    const { updateConnectionID } = useAxiosInterceptor() 

    const updateConnectionId = (connectionId) => {
        setConnectionId(connectionId);
        updateConnectionID(connectionId);

    };
    const updateConnection = (connection) => {
        setConnection(connection);
        updateConnectionId(connection.connectionId);
    }

    useSignalR({ name: "realTimeManager", updateConnection });

    return (
        <HubConnectionContext.Provider value={{ connection, setConnection, connectionId }}>
            {children}
        </HubConnectionContext.Provider>
    );
};

export const useHubConnection = () => useContext(HubConnectionContext);